import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { checkupSave } from "../../requests/case.js";

export default function useCheckupCase(props) {

  const [caseForm, setCaseForm] = createStore({
    title: props.case?.title || "",
    notes: props.case?.notes || "",
  });

  const { successToast, errorToast } = useApplication();

  const handleCaseInput = (name, value) => {
    setCaseForm([name], value);
  }

  const onSaveCase = async () => {
    props.setLoading(true);
    try {
      const formData = new FormData();
      formData.append('title', caseForm.title);
      formData.append('notes', caseForm.notes);

      const data = await checkupSave(formData);

      if (data.success) {
        successToast(data.message || "Case saved successfully");
      } else {
        errorToast(data.message || "Failed to save case");
      }
    } catch(error) {
      errorToast("Failed to save case");
    } finally {
      props.setLoading(false);
    }
  }

  return {
    caseForm,
    onSaveCase,
    handleCaseInput,
  };
} 